export const GET_PHOTOS_BEOGRAD =
  "https://travels.findingluisa.com/api/get-photos?pattern=beograd";
export const ARCHITECTURE_PATH =
  "https://travels.findingluisa.com/architecture/";
export const UPDATE_PHOTO = "https://travels.findingluisa.com/api/update-photo";
export const HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
export const DELETE_LIKE =
  "https://travels.findingluisa.com/api/delete-reaction";
export const mapping = {
  blue_heart: "💙",
  grey_heart: "🩶",
  light_blue_heart: "🩵",
  pink_heart: "🩷",
  black_heart: "🖤",
  white_heart: "🤍",
  green_heart: "💚",
  yellow_heart: "💛",
  purple_heart: "💜",
  orange_heart: "🧡",
  heart: "❤️",
  eyes: "👀",
  fart: "💨",
  flower: "🌸",
  sun: "☀️",
  car: "🚗",
  minibus: "🚐",
  rose: "🌹",
  cat: "🐈‍⬛",
  dog: "🐕",
  serbia_flag: "🇷🇸",
  coffee: "☕,",
  swimming_pool: "🌊",
  sparkle: "✨",
  candle: "🕯️",
  notes: "🎶",
  yellow: "🟡",
  zap: "⚡",
  paintbrush: "🖌️",
  fish: "🐠",
  trolleybus: "🚋",
  traffic_light: "🚦",
};
